module.exports = __webpack_public_path__ + "img/app.b49cee1a.jpg";